import type { PurposeType } from './checkoutApi.js';
import type { SessionMetadataCheckoutMode, SessionMetadataCollect } from 'pi-kiosk-shared';

export type CheckoutSubMode = SessionMetadataCheckoutMode['selectedMode'];

export interface PaymentRailsMobile {
  bankTransfer: boolean;
  gateway: boolean;
}

export interface MobileRailPolicyInput {
  purposeType: PurposeType;
  checkoutMode: SessionMetadataCheckoutMode;
  collect: SessionMetadataCollect | null;
  paymentRailsMobile: PaymentRailsMobile;
  gatewayHealthAvailable: boolean;
}

/** E5 — PWA rails from `paymentRailsMobile` even for KIOSK_FIRST handoff; DONATION without collect. */
export function resolveMobileCheckoutRails(input: MobileRailPolicyInput): {
  bankQr: boolean;
  gateway: boolean;
} {
  if (input.checkoutMode.channel === 'MOBILE_FIRST' && input.checkoutMode.selectedMode === 'PAY_NOW_STAFF_HANDOFF') {
    return { bankQr: false, gateway: false };
  }

  const onPwaPaySurface =
    input.checkoutMode.channel === 'MOBILE_FIRST' || input.checkoutMode.channel === 'KIOSK_FIRST';
  if (!onPwaPaySurface) {
    return { bankQr: false, gateway: false };
  }

  if (input.purposeType === 'DONATION') {
    return {
      bankQr: input.paymentRailsMobile.bankTransfer,
      gateway: input.paymentRailsMobile.gateway && input.gatewayHealthAvailable,
    };
  }

  if (input.collect === null) {
    return { bankQr: false, gateway: false };
  }

  return {
    bankQr: input.paymentRailsMobile.bankTransfer,
    gateway: input.paymentRailsMobile.gateway && input.gatewayHealthAvailable,
  };
}

/** @deprecated Use resolveMobileCheckoutRails — kept for legacy call sites during migration. */
export function isMobileBankQrAllowed(
  collect: SessionMetadataCollect,
  checkoutMode: SessionMetadataCheckoutMode
): boolean {
  return (
    checkoutMode.channel === 'MOBILE_FIRST' &&
    collect.timing === 'LATER'
  );
}

/** @deprecated Use resolveMobileCheckoutRails */
export function isMobileGatewayAllowed(
  collect: SessionMetadataCollect,
  checkoutMode: SessionMetadataCheckoutMode,
  paymentRailsMobileGateway: boolean
): boolean {
  return (
    paymentRailsMobileGateway &&
    checkoutMode.channel === 'MOBILE_FIRST' &&
    collect.timing === 'LATER'
  );
}
